import logo from './logo.png';
import eit1 from './eit1.png';
import eit2 from './eit.png';
import loga from './loga.png';
import loga2 from './loga2.png';
import plagat from './plagat.pdf';
import './App.css';
import './satoshi.css';

function App() {
    return (
        <div className="App">
            <div className="Background">
                <img src={logo} className="Logo" alt="logo"/>
                <header className="my-header">
                    We’ll be back soon!
                </header>
                <p className="my-text">We are working hard to bring you latest updates on<br />
                    marking pheromones for safe & affordable pest control<br />
                    <br />
                    Contact us at: <a href="mailto:info@noovi.tech">info@noovi.tech</a> </p>

                <p className="my-footer">
                    <br />
                {/*<img src={eit1} className="eit1" alt="eit1"/>*/}
                {/*<img src={eit2} className="eit2" alt="eit2"/>*/}
                {/*<img src={loga} className="loga" alt="loga"/>*/}
                <img src={loga2} className="loga2" alt="loga2"/>
                    <p className="eu-text">The Pheromark® project is funded by the European Union under the Recovery and Resilience Plan of the Slovak Republic.<br />
                        <a href={plagat} target="_blank" rel="noopener noreferrer">More information about the project.</a></p>
                </p>
            </div>
        </div>
    );
}

export default App;
